module.exports = __webpack_public_path__ + "img/hvor-er-mine-likes-2.4d66f539.png";